import {
    ACTION_LOADING,
    ACTION_ERROR,
    ACTION_GET_LIST,
    ACTION_GET_STATISTICS,
    ACTION_RESET_LIST,
    ACTION_PAYMENT_STATUS,
    ACTION_TASK_TYPES,
    ACTION_GET_TRIP_BY_ID,
    ACTION_EDIT_DURATION_BY_ID
} from "actions/action/constants";

const initialState = {
    loading: false,
    errors: [],

    actionList: {},
    taskTypes: {},
    paymentStatus: {},
    singleTrip: [],
    actionStatistics: [],
    editDurationLoading: false
};

export default function(state = initialState, action) {
    let taskTypes,
        paymentStatus;
    switch (action.type) {
        case ACTION_LOADING:
            return {
                ...state,
                loading: action.payload.content
            };
        case ACTION_ERROR:
            return {
                ...state,
                errors: action.payload.content
            };
        case ACTION_GET_LIST:
            return {
                ...state,
                actionList: action.payload
            };
        case ACTION_GET_STATISTICS:
            return {
                ...state,
                actionStatistics: action.payload
            };
        case ACTION_RESET_LIST:
            return {
                ...state,
                actionList: {}
            };
        case ACTION_TASK_TYPES:
            taskTypes = {};
            action.payload.forEach((value, index) => {
                taskTypes[index] = value;
            });
            return {
                ...state,
                taskTypes
            };
        case ACTION_PAYMENT_STATUS:
            paymentStatus = {};
            action.payload.forEach((value, index) => {
                paymentStatus[index] = value;
            });
            return {
                ...state,
                paymentStatus
            };
        case ACTION_GET_TRIP_BY_ID:
            return {
                ...state,
                loading: false,
                singleTrip: action.payload
            };
        case ACTION_EDIT_DURATION_BY_ID:
            return {
                ...state,
                editDurationLoading: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/actionReducer.js